import React from 'react';

const Settings = ({ toggleTheme, theme }) => {
  return (
    <div className="WSNG-settings-container">

    </div>
  );
};

export default Settings;
